import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Textarea } from './ui/Textarea';
import { Label } from './ui/Label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/Select';
export function QuoteForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <section id="quote" className="py-20 md:py-32 bg-muted/30" data-id="element-107">
      <div className="container mx-auto px-4 md:px-6" data-id="element-108">
        <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-border flex flex-col lg:flex-row" data-id="element-109">
          {/* Left Side: Copy */}
          <div className="bg-primary text-white p-10 lg:p-16 lg:w-5/12 flex flex-col justify-center" data-id="element-110">
            <h2 className="font-heading text-4xl md:text-5xl font-bold mb-6 uppercase leading-tight" data-id="element-111">
              Get Your <span className="text-accent" data-id="element-112">Free Quote</span>
            </h2>
            <p className="text-lg text-white/80 mb-8" data-id="element-113">
              Ready to restore your property? Fill out the form, and we will get
              back to you within 24 hours with a custom estimate. No hidden
              fees, no pressure.
            </p>
            <ul className="space-y-4 text-lg font-medium" data-id="element-114">
              <li className="flex items-center gap-3" data-id="element-115">
                <CheckCircle2 className="w-6 h-6 text-accent" data-id="element-116" />
                Fast Response Time
              </li>
              <li className="flex items-center gap-3" data-id="element-117">
                <CheckCircle2 className="w-6 h-6 text-accent" data-id="element-118" />
                Upfront Pricing
              </li>
              <li className="flex items-center gap-3" data-id="element-119">
                <CheckCircle2 className="w-6 h-6 text-accent" data-id="element-120" />
                100% Satisfaction Guarantee
              </li>
            </ul>
          </div>

          {/* Right Side: Form */}
          <div className="p-10 lg:p-16 lg:w-7/12" data-id="element-121">
            {isSubmitted ? <div className="h-full flex flex-col items-center justify-center text-center space-y-6 py-12" data-id="element-122">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-123">
                  <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-124" />
                </div>
                <h3 className="font-heading text-3xl font-bold text-primary" data-id="element-125">
                  Quote Request Sent!
                </h3>
                <p className="text-lg text-muted-foreground max-w-md" data-id="element-126">
                  Thank you for reaching out. Our team will review your request
                  and contact you shortly.
                </p>
                <Button onClick={() => setIsSubmitted(false)} variant="outline" className="mt-4" data-id="element-127">
                  Submit Another Request
                </Button>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-128">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-129">
                  <div className="space-y-2" data-id="element-130">
                    <Label htmlFor="name" className="text-base font-bold text-primary" data-id="element-131">
                      Full Name
                    </Label>
                    <Input id="name" required placeholder="John Doe" className="h-12 text-base" data-id="element-132" />
                  </div>
                  <div className="space-y-2" data-id="element-133">
                    <Label htmlFor="phone" className="text-base font-bold text-primary" data-id="element-134">
                      Phone Number
                    </Label>
                    <Input id="phone" type="tel" required placeholder="(555) 123-4567" className="h-12 text-base" data-id="element-135" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-136">
                  <Label htmlFor="service" className="text-base font-bold text-primary" data-id="element-137">
                    Service Needed
                  </Label>
                  <Select required data-id="element-138">
                    <SelectTrigger className="h-12 text-base" data-id="element-139">
                      <SelectValue placeholder="Select a service" data-id="element-140" />
                    </SelectTrigger>
                    <SelectContent data-id="element-141">
                      <SelectItem value="driveway" data-id="element-142">
                        Driveway & Concrete Cleaning
                      </SelectItem>
                      <SelectItem value="siding" data-id="element-143">
                        House & Siding Washing
                      </SelectItem>
                      <SelectItem value="roof" data-id="element-144">Roof Soft Washing</SelectItem>
                      <SelectItem value="deck" data-id="element-145">
                        Deck & Patio Cleaning
                      </SelectItem>
                      <SelectItem value="fence" data-id="element-146">Fence Washing</SelectItem>
                      <SelectItem value="commercial" data-id="element-147">
                        Commercial Pressure Washing
                      </SelectItem>
                      <SelectItem value="multiple" data-id="element-148">
                        Multiple Services
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2" data-id="element-149">
                  <Label htmlFor="message" className="text-base font-bold text-primary" data-id="element-150">
                    Additional Details
                  </Label>
                  <Textarea id="message" placeholder="Tell us a bit about the project size or specific areas of concern..." className="min-h-[120px] text-base resize-y" data-id="element-151" />
                </div>

                <Button type="submit" size="lg" className="w-full bg-accent hover:bg-accent/90 text-white font-bold h-14 text-lg mt-4" data-id="element-152">
                  Request Free Quote
                </Button>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}